import { UpdateUserEmailPayload } from 'app/api/user'
import * as Yup from 'yup'

export type UpdateUserEmailFormData = {
  email: string
}

export const updateUserEmailDefaultValues: UpdateUserEmailFormData = {
  email: '',
}

export const updateUserEmailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Formato non valido')
    .required('Campo obbligatorio'),
})

export const adaptUpdateUserEmailFormDataToAPI = (
  formData: UpdateUserEmailFormData
): UpdateUserEmailPayload => ({
  email: formData.email,
})
